module.exports = __webpack_public_path__ + "img/bank_icon13.4dddb102.png";